import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-fifteen-minutes',
  standalone: true,
  imports: [],
  templateUrl: './fifteen-minutes.html',
  styleUrls: ['./fifteen-minutes.scss'],
})
export class FifteenMinutes{
  public status: InputSignal<'past' | 'present' | 'future'> = input.required<'past' | 'present' | 'future'>();
}
